// main
import ContentFormatXX from '../content/webz/content-format-xx';
import WebbDividerSmall from '../content/webx/webb-divider-sm';
import WebbDividerMedium from '../content/webx/webb-divider-md';

import OnboardUserModule from '../content/onboard/onboard-user';


export default function OnboardUser() {
  
  return (
    <ContentFormatXX 
      head = {'Onboard User'}
      home = {`/`}
      link = {`/auth/next`}
      form = {'mini'}
      data = {
        <>
          <WebbDividerSmall />
          <OnboardUserModule />
          
        </>
        
      }  
    /> 
  )
}